export default __webpack_public_path__ + "static/media/altlantique-min.1ef11baf.webp";